import { openModal } from './modal';

export const openDialogRemoveItems = (tree, nodeItem) =>
  openModal('RemoveItemsDialog', { tree, nodeItem });
